import { QueryHandler } from "../event-driven/core-utils/core-decorators";
import AxiosAPIInterface from "./axios-api-interface";

export const RECURRING_JOB_API = {
	CHECK_JOB_EXIST: "CHECK_JOB_EXIST"
};

export default class RecurringJobsAPI extends AxiosAPIInterface {
	constructor() {
		if (RecurringJobsAPI._instance) {
			return RecurringJobsAPI._instance;
		}
		super({ resoucePath: "/recurring-jobs" });
		RecurringJobsAPI._instance = this;
	}

	@QueryHandler(RECURRING_JOB_API.CHECK_JOB_EXIST)
	checkJobExists() {
		return this.get({ path: "/exists" });
	}
}
